<template>
  <va-modal
    size="large"
    :value="showModal"
    ref="cloneAnamneseModal"
    :okText="$t('modals.defaults.button_save')"
    :cancelText="$t('modal.cancel')"
    @ok="handleClone()"
    @cancel="handleCancel()"
    :okDisabled="isSubmiting || disabled"
  >
    <div slot="header" class="d-flex justify--space-between">
      <span class="modal-title">{{$t('evohealth.anamneses.clone', {title: anamnese.name})}}</span>
    </div>

    <div class="row evollu-form mb-5">
      <div class="row">
        <span>{{$t('evohealth.anamneses.clone_body')}}</span>
      </div>

      <div class="col-12">
        <div>
          <label class="form-label">{{ $t('menu.entities') }}:</label>
          <multiselect
            v-model="selectedEntities"
            :options="entities"
            track-by="id"
            label="name"
            :custom-label="formatedEntityLabel"
            :placeholder="$t('menu.entities')"
            select-label=""
            selected-label=""
            deselect-label=""
            :allow-empty="false"
            :multiple="true"
            :close-on-select="false"
            :limit="3"
            :limit-text="(count) => $t('tables.multiselect_limitText_and') + count + this.$t('tables.multiselect_limitText_others')"
            :searchable="true">
            <template slot="clear">
                <span class="multiselect__clear" v-if="selectedEntities.length && selectedEntities.length > 0"
                      @mousedown.prevent.stop="selectedEntities = []"></span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

  </va-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import MultiselectLabelFormatter from '@/mixins/MultiselectLabelFormatter.vue';
import { EvohealthService } from '@/api/EvohealthService';

export default {
  components: { Multiselect },
  mixins: [MultiselectLabelFormatter],
  props: {
    anamnese: {
      type: Object,
      required: true
    },
    entities: {
      type: Array,
      required: true,
      default: []
    }
  },
  data() {
    return {
      showModal: false,
      isSubmiting: false,
      selectedEntities: []
    }
  },
  mounted () {
    this.showModal = true
  },
  methods: {
    handleClone: async function() {
      const data = {}
      data.entities = this.selectedEntities.map(ent => ent.id)
      data.id = this.anamnese.id
      try {
        await EvohealthService.cloneAnamnese(data)
        this.$emit('clonedSuccess')
        setTimeout(() => {
          this.showModal = false
        }, 500)
      } catch(err) {
        this.showToast(this.$t('auth.tfa.errors.generic'), this.$store.state.errorToastOptions)
        console.log(err)
      }

    },
    handleCancel: function() {
      this.$emit('cancel')
      this.showModal = false
    }
  },
  computed: {
    disabled: function () {
      return this.selectedEntities.length === 0
    }
  }
};
</script>

<style lang="scss">
.multiselect__content-wrapper {
  position: static !important;
}

</style>
